import { Component, Input } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'response-card',
    templateUrl: './response-card.component.html'
})
export class ClientMockResponseCardComponent {
    @Input() public messageCard: any;

    constructor() {}
}
